import { jsxs as h, jsx as l } from "react/jsx-runtime";
const v = (r) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M57.988 28.941v-7.916L31.992 6.048 6.012 21.025v7.915h5.974v25.035h-5.84l1.071 3.996h50.636l-1.071-3.996h-4.805V28.94h6.01l.001.001Zm-47.98-5.607L31.993 10.66l21.999 12.674v1.611H10.008v-1.611Zm16.453 30.641H15.982V28.94h14.02v25.035h-3.541Zm21.521 0H33.998V28.94h13.984v25.035Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m33.617 15.807-4.418 1.184 1.184 4.418 4.418-1.184-1.184-4.418Z"
        }
      )
    ]
  }
);
export {
  v as PayByBankTransfer
};
